<template>
  <div class="app-container">
    <ChatbotComponent
      ref="chatbotComponent"
      title="自己分析 - AIヤギ"
      :showBackButton="false"
      :useDefaultApi="false"
      :greetingMessage="messages[0].content"
      :showInfoButton="true"
      :infoContent="interviewerInfoContent"
      :requireLogin="true"
      :requirePayment="true"
      paymentFeature="ai-self-analysis"
      :paymentTiming="6"
      @message-sent="handleMessageSent"
      @chat-reloaded="handleChatReloaded"
      :showInputContainer="hasRequiredFormat"
    >
      <template slot="auxiliary">
        <div class="self-analysis-report">
          <h3 class="report-title">自己分析レポート</h3>
          <div class="report-content" v-if="finalReport" v-html="finalReport"></div>
          <p v-else>まだデータがありません。対話を進めるとレポートが作成されます。</p>
        </div>
      </template>
    </ChatbotComponent>

    <CreateFormatDialog ref="createFormatDialog" />
  </div>
</template>

<script>
import ChatbotComponent from './ChatbotComponent.vue'
import AptitudeReport from '../../../components/aptitude/AptitudeReport.vue'
import CreateFormatDialog from '../../../components/CreateFormatDialog.vue'

export default {
  name: 'AptitudeChat',
  components: {
    ChatbotComponent,
    AptitudeReport,
    CreateFormatDialog
  },
  props: {
  },
  data () {
    return {
      userMessageCount: 0,
      messages: [
        {
          role: 'assistant',
          content: 'こんにちは！自己分析(β版)へようこそ。\n\n私はあなたとの対話を通して、あなたを分析をするAIヤギです。\nまだまだ成長中につき、優しくしてください。'
        }
      ],
      selectedTestType: '',
      pastQuestions: [],
      lastProblemMetadata: null,
      hasRequiredFormat: true,
      isFormatChecking: false,
      finalReport: null
    }
  },
  computed: {
    apiParams () {
      return {
        uuid: this.$firebase.user ? this.$firebase.user.uid : '',
        prompt: this.messages
      }
    },
    interviewerInfoContent () {
      return '<p>適性検査</p>'
    }
  },
  created () {
    // ユーザーメッセージの数をカウント
    this.$yagiprimePaymentService.init(this)
  },
  mounted () {
    // cookieからデータを復元（コンポーネントが初期化された後に行う）
    this.loadDataFromCookie()
  },
  beforeMount () {
    this.$eventHub.$on('auth_state_changed', this.authStateChanged)
  },
  watch: {
    messages: {
      handler: function (newMessages) {
        this.saveDataToCookie()
      },
      deep: true
    },
    finalReport: function (newReport) {
      if (newReport) {
        this.saveDataToCookie()
      }
    }
  },
  destroyed () {
    // サービスのクリーンアップ
    this.$yagiprimePaymentService.cleanup(this)
    this.$eventHub.$off('auth_state_changed', this.authStateChanged)
  },
  methods: {
    async authStateChanged () {
      try {
        const formData = new FormData()
        formData.append('uuid', this.$firebase.user ? this.$firebase.user.uid : '')
        formData.append('version', '2')
        formData.append('reqflg', '2')
        formData.append('email', this.$firebase.user ? this.$firebase.user.email : '')
        formData.append('site_flag', 'r')
        formData.append('device_flag', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
        formData.append('email_verified', this.$firebase.user ? this.$firebase.user.emailVerified ? '1' : '0' : '0')

        const response = await this.$axios.post(this.$varuna.endPoints.getMypageHistory, formData, { timeout: 60000 })
        const history = response.data.format_ids
        const requiredFormats = ['rirekisho_job_new', 'rirekisho_job_new_single', 'internship', 'entrysheet']
        const formatExists = requiredFormats.some(format =>
          history.some(item => item.format_id === format)
        )

        // 必要なテンプレートがない場合のみfalseに設定
        if (!formatExists) {
          this.hasRequiredFormat = false
          // テンプレート作成ダイアログを表示
          this.$refs.createFormatDialog.openDialog()
          // 必要なテンプレートがない場合は、メッセージを表示
          this.$refs.chatbotComponent.showBotMessageFromParent(
            '学生向けのテンプレートを作成してください。'
          )
        }
      } catch (error) {
        console.error('テンプレートチェックに失敗しました:', error)
        // エラー時もデフォルトでtrueのまま
      }
    },
    handleMessageSent (event) {
      if (!this.hasRequiredFormat) {
        return
      }
      const app = this
      this.$refs.chatbotComponent.isTyping = true

      // ユーザーの選択または回答をメッセージに追加
      this.messages.push({ role: 'user', content: event.userMessage })

      const params = {
        uuid: this.$firebase.user ? this.$firebase.user.uid : '',
        prompt: this.messages
      }

      this.$axios.post(this.$varuna.endPoints.aiSelfAnalysisChat, params)
        .then(res => {
          const reply = res.data.response.response
          this.messages.push({
            role: 'assistant',
            content: reply
          })

          // final_reportがある場合は設定
          if (res.data.response.final_report) {
            this.finalReport = res.data.response.final_report
          }

          // APIレスポンス受信後に即座にcookieを更新
          this.saveDataToCookie()

          console.log(reply)
          app.$refs.chatbotComponent.showBotMessageFromParent(
            reply,
            null
          )
        })
        .catch(err => {
          console.log(err)
        })
    },
    handleChatReloaded () {
      this.companyInfoLocal = ''
      this.motivationLocal = ''
      this.userMessageCount = 0
      this.finalReport = null
      // cookieのデータをクリア
      this.clearCookieData()
    },
    handleGreetingDisplayed () {
      // ChatbotComponentのisTypingをtrueにする
      this.$refs.chatbotComponent.isTyping = true
      this.$refs.chatbotComponent.showBotMessageFromParent(
        this.firstMessage,
        this.firstMessageActions
      )
      const content = this.firstMessage
      this.messages.push({
        role: 'assistant',
        content
      })
    },
    // cookieにデータを保存するメソッド
    saveDataToCookie () {
      const dataToSave = {
        messages: this.messages,
        finalReport: this.finalReport
      }
      console.log(dataToSave)
      // ローカルストレージに保存
      localStorage.setItem('_YAGISH_SELF_ANALYSIS_DATA', JSON.stringify(dataToSave))
    },
    // cookieからデータを読み込むメソッド
    loadDataFromCookie () {
      try {
        // ローカルストレージからデータを取得
        const savedData = localStorage.getItem('_YAGISH_SELF_ANALYSIS_DATA')
        // データが存在しない場合は終了
        if (!savedData) return

        const parsedData = JSON.parse(savedData)

        // メッセージと最終レポートを復元
        if (parsedData.messages && parsedData.messages.length > 0) {
          this.messages = parsedData.messages
          // ChatbotComponentが初期化されていることを確認
          if (this.$refs.chatbotComponent) {
            this.$refs.chatbotComponent.messages = parsedData.messages.map(msg => {
              return {
                sender: msg.role === 'assistant' ? 'bot' : 'user',
                text: msg.content
              }
            })

            // ユーザーメッセージの数をカウントして設定
            const userMessageCount = parsedData.messages.filter(msg => msg.role === 'user').length
            this.$refs.chatbotComponent.messageCount = userMessageCount
            this.userMessageCount = userMessageCount

            // 会話があった場合はhasInteractedをtrueに設定
            if (userMessageCount > 0) {
              this.$refs.chatbotComponent.hasInteracted = true
            }
          }
        }
        if (parsedData.finalReport) {
          this.finalReport = parsedData.finalReport
        }
      } catch (error) {
        console.error('ローカルストレージからのデータ読み込みに失敗しました:', error)
        // エラーが発生した場合はローカルストレージのデータを削除
        this.clearCookieData()
      }
    },
    // ローカルストレージのデータをクリアするメソッド
    clearCookieData () {
      localStorage.removeItem('_YAGISH_SELF_ANALYSIS_DATA')
    }
  }
}
</script>

<style scoped>
.app-container {
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
}

.self-analysis-report {
  padding: 20px;
  border-radius: 8px;
  max-width: 768px;
  background-color: white;
  margin: 20px auto;
  border: 1px solid #dfdfdf
}

.report-title {
  font-size: 1.5rem;
  color: #0F9934;
  margin-bottom: 15px;
  text-align: center;
}

.report-content {
  line-height: 1.6;
}

.report-content >>> h1,
.report-content >>> h2,
.report-content >>> h3 {
  color: #0F9934;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
}

.report-content >>> h1 {
  font-size: 1.5rem;
  border-bottom: 2px solid #0F9934;
  padding-bottom: 5px;
}

.report-content >>> h2 {
  text-align: left;
  font-size: 1.3rem;
}

.report-content >>> h3 {
  font-size: 1.1rem;
}

.report-content >>> ul,
.report-content >>> ol {
  padding-left: 20px;
  margin-bottom: 15px;
}

.report-content >>> p {
  margin-bottom: 15px;
}

.report-content >>> strong {
  color: #0F9934;
}

.report-content >>> blockquote {
  border-left: 3px solid #0F9934;
  padding-left: 15px;
  color: #666;
  font-style: italic;
  margin: 15px 0;
}
</style>
